import React from "react";
import PropTypes from "prop-types";
import DOMPurify from "dompurify";

export default function PaymentError(props) {
  const { errorMessage, innerRef, testId } = props;
  return (
    <div ref={innerRef} className="payment-form-messages">
      {errorMessage && (
        <div
          id="payment-form-error-message"
          className="lc-banner lc-banner-warning lc-banner-section payment-errors"
          data-testid={testId}
          dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(errorMessage) }}
        />
      )}
    </div>
  );
}

PaymentError.propTypes = {
  errorMessage: PropTypes.string,
  testId: PropTypes.string
};

PaymentError.defaultProps = {
  errorMessage: null,
  testId: null
};
